import "./Footer.css";
import {
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaFacebook,
  FaLinkedin,
  FaXTwitter,
} from "react-icons/fa6";
import logo from "../assets/logo-ct-dark.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left: Logo + tagline */}
        <div className="footer-top">
          <img src={logo} alt="ChipServer Logo" className="footer-logo" />
          <p>
            The Ultimate Mobile Data Storage, Streaming & Broadcasting Solution
          </p>
        </div>

        {/* Center: Quick Links */}
        <div className="footer-nav">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/portable-classroom">Portable Classroom</a></li>
            <li><a href="/blog">Blog</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/careers">Careers</a></li>
          </ul>
        </div>

        {/* Right: Social Media */}
        <div className="footer-social">
          <h4>Connect</h4>
          <p>Follow us on social media for updates and news.</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/thechipserver/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/@ChipServerllc" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="https://www.tiktok.com/@thechipserver" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <FaTiktok />
            </a>
            <a href="https://www.facebook.com/people/Chipserver-LLC/61570322474036/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href="https://x.com/ChipServerLLC" target="_blank" rel="noopener noreferrer" aria-label="X">
              <FaXTwitter />
            </a>
            <a href="https://www.linkedin.com/company/the-chipserver-llc" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} ChipServer LLC. All rights reserved.</p>
        <p>
          Website Created and Supported by{" "}
          <a
            className="footer-credit-link"
            href="https://vicisecurity.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vici Tech Solutions
          </a>
        </p>
      </div>
    </footer>
  );
}
